/**
 * Created by quikr on 8/1/16.
 */
import {displayError, noError} from "./errorActions";

const error = {
  "errors": [
    {
      "attributeName": "server",
      "errorMessage": "Server is down. Try again later!!",
      "errorCode": "SERVER_DOWN"
    }
  ]
};
export function storeServerError(dispatch, server_error) {

  //Do some manipulation to error object before dispatching it as an action (if required)
  dispatch(displayError(server_error));
  dispatch(noError());
}
export default error;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/Errors/error.class.js
 **/